const getColor = (code) => {
  const e = document.querySelector(":root");
  return getComputedStyle(e).getPropertyValue(code);
};

export const colors = {
  cyan1: "#E6FFFB",
  cyan2: "#B5F5EC",
  cyan3: "#87E8DE",
  cyan4: "#5CDBD3",
  cyan5: "#5CDBD3",
  cyan6: "#13C2C2",
  cyan7: "#08979C",
  cyan8: "#006D75",

  ColorsNeutralTextcolorTextSecondary: getColor(
    "--Colors-Neutral-Text-colorTextSecondary",
  ),
  ColorsNeutralTextcolorTextQuaternary: getColor(
    "--Colors-Neutral-Text-colorTextQuaternary",
  ),
  ColorsBaseCyan10: getColor("--Colors-Base-Cyan-10"),
  ComponentsAlertGlobalcolorErrorBg: getColor(
    "--Components-Alert-Global-colorErrorBg",
  ),
  ColorsNeutralTextcolorTextTertiary:
    "var(--Colors-Neutral-Text-colorTextTertiary, rgba(0, 0, 0, 0.45))",

  black2: "#00000005",
  black0: "#000000",
  black4: "rgb(0, 0, 0, 0.04)",
  black6: "rgb(0, 0, 0, 0.06)",
  black15: "rgb(0, 0, 0, 0.15)",
  black18: "#000000E0",
  black20: "rgba(0, 0, 0, 0.2)",
  black50: "rgba(0, 0, 0, 0.5)",
  black65: "#000000A6",
  black85: "rgba(0, 0, 0, 0.85)",
  black88: "#000000E0",
  blackText: "#08090D",

  grey: "#F0F0F0",
  grey2: "#F5F5F5",
  greyText: "#000000A6",
  borderGrey: "#D9D9D9",
  grey3: "#a7a5a5",
  grey4: "rgba(63, 70, 89, 0.3)",
  grey5: "rgba(0, 0, 0, 0.02)",
  grey6: "rgba(0, 0, 0, 0.45)",

  white: "#FFF",

  yellow1: "#FAAD14",

  errorRed: "#FF4D4F",
  errorRedBg: "#FFF2F0",
  errorRedBorder: "#FFCCC7",
  errorRedText: "#FF4DAF",
  errorRedHover: "#FF7875",
  errorRedTextActive: "#D9363E",
  errorRed2TextActive: "#FF4D4F",

  lightRed0: "#FFCCC7",
  deepRed0: "#CF1322",
  lightBlue0: "#F5F9FA",
  baseBlue: "var(--Colors-Base-Blue-6, #1677FF)",
  baseGreen: "var(--Colors-Base-Green-7, #389E0D)",
  baseGreen1: "var(--Colors-Base-Green-1, #F6FFED)",

  baseRed6: "#F5222D",
  blackDisclaimer: "#00000073",

  boxShadowSecondary: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  colorBorderSecondary:
    "1px solid var(--Colors-Neutral-Border-colorBorderSecondary, #F0F0F0)",
  colorTextSecondary:
    "var(--Colors-Neutral-Text-colorTextSecondary, rgba(0, 0, 0, 0.65))",
  borderRadius:
    "var(--Components-Radio-Global-borderRadius, 6px) 0 0 var(--Components-Radio-Global-borderRadius, 6px)",
  border:
    "var(--Components-Radio-Global-lineWidth, 1px) solid var(--Components-Radio-Global-colorBorder, #D9D9D9)",
  backgroundWhite: "var(--Components-Radio-Component-buttonBg, #FFF)",
  neutralColorBorder:
    "1px solid var(--Colors-Neutral-Border-colorBorder, #D9D9D9)",
  radioBorderRadiusRight:
    "0 var(--Components-Radio-Global-borderRadius, 6px) var(--Components-Radio-Global-borderRadius, 6px) 0",
  borderRadiusSM: " var(--Components-Tag-Global-borderRadiusSM, 4px)",
  borderGreen:
    "var(--Components-Tag-Global-lineWidth, 1px) solid var(--Colors-Base-Green-3, #B7EB8F)",
};
